// Source-entry signature helpers for rebuild invalidation decisions.
// Includes runtime option state so data-luis toggles trigger recompilation.
import type { LuisSourceElement } from '../context'
import { readLuisManifestAttribute, readLuisRuntimeOptions, readLuisStyleOutputMode } from '../options'

// Build canonical runtime option signature for one source element.
export function buildOptionsSignature(source: LuisSourceElement): string {
  const options = readLuisRuntimeOptions(source)
  const manifest = readLuisManifestAttribute(source) ?? ''
  const outputMode = readLuisStyleOutputMode(source)
  // Return deterministic options signature for cache comparison.
  return `debug:${options.debug};performance:${options.performance};map:${options.map};lazy:${options.lazy};worker:${options.worker};manifest:${manifest};output:${outputMode}`
}

// Build a stable signature string for one link source entry.
export function buildLinkSignature(
  href: string,
  rawSource: string,
  importSignature: string,
  optionsSignature: string,
): string {
  // Return deterministic link signature including runtime options.
  return `link:${href}\n${rawSource}\nimports:${importSignature}\noptions:${optionsSignature}`
}

// Build a stable signature string for one inline source entry.
export function buildInlineSignature(
  rawSource: string,
  importSignature: string,
  optionsSignature: string,
): string {
  // Return deterministic inline signature including runtime options.
  return `inline:${rawSource}\nimports:${importSignature}\noptions:${optionsSignature}`
}
